export default __webpack_public_path__ + "static/media/ANT.f2c8815b.svg";